import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, checkAdmin } from '../utils/api';
import './Login.css';
import logo from '../assets/logo.png';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const navigate = useNavigate();
  const { refreshAuth } = useAuth();
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      refreshAuth().then((isAdmin) => {
        navigate(isAdmin ? '/admin' : '/dashboard', { replace: true });
      });
    }
  }, [navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(formData.username, formData.password);
      localStorage.setItem('token', data.access_token);
      localStorage.setItem('refresh_token', data.refresh_token);
      localStorage.setItem('username', formData.username);
      const isAdmin = await refreshAuth();
      navigate(isAdmin ? '/admin' : '/dashboard', { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='login-page'>
      <div className='login-container'>
        <div className='login-card'>
          <div className='login-header'>
            <div className='login-logo'>
              <img src={logo} alt='Company Logo' className='nav-logo' />
            </div>
            <p className='login-subtitle'>Sign in to your account</p>
          </div>

          <form onSubmit={handleSubmit} className='login-form'>
            {error && <div className='alert alert-error'>{error}</div>}

            <div className='form-group'>
              <label htmlFor='username' className='label'>
                Email
              </label>
              <input
                type='email'
                id='username'
                name='username'
                className='input'
                value={formData.username}
                onChange={handleChange}
                placeholder='you@example.com'
                required
                autoFocus
                disabled={loading}
              />
            </div>

            <div className='form-group'>
              <label htmlFor='password' className='label'>
                Password
              </label>
              <input
                type='password'
                id='password'
                name='password'
                className='input'
                value={formData.password}
                onChange={handleChange}
                placeholder='••••••••'
                required
                disabled={loading}
              />
            </div>

            <button type='submit' className='btn btn-primary btn-block' disabled={loading}>
              {loading ? (
                <>
                  <span className='spinner'></span>
                  Signing in...
                </>
              ) : (
                'Sign in'
              )}
            </button>
          </form>

          <div className='login-footer'>
            <p className='login-forgot'>
              <a href='/forgot-password'>Forgot password?</a>
            </p>

            <p className='login-help'>Need help? Contact your administrator</p>
          </div>
        </div>

        <div className='login-background'>
          <div className='bg-gradient'></div>
          <div className='bg-grid'></div>
        </div>
      </div>
    </div>
  );
};

export default Login;
